import { Heading, Text, Img } from "./..";
import React from "react";

export default function UserProfile1({myAd}) {
  return (
    <div
      className={`flex flex-col items-center self-stretch p-2 border-gray-200 border border-solid flex-1 rounded-lg`}
    >
      <div
       className="flex items-start">
        {myAd.title == "מודעות חדשות" &&
        <Img src="images/img_signal_red_a700_03.svg" alt="Image" className="h-[10px]" />
        }
        <div
        style = {{color: myAd.color}}
         className="flex items-start gap-1.5 self-center">
          <Img src={myAd.img} alt="Image" className="mt-3 h-[24px]" />
          <Text
          style = {{color: myAd.color, fontSize: '30px'}}
           size="text9xl" as="p" className="self-center text-[20px] font-normal">
            {myAd.number}
          </Text>
        </div>
      </div>
      <Heading 
      
      size="h5_assistant_12px_r" as="p" className="relative mt-[-2px] text-[12px] font-semibold">
        {myAd.title}
      </Heading>
    </div>
  );
}
